export { CepPipeModule } from './cep/cep.module';
export { MoneyPipeModule } from './money/money.module';
export { PhonePipeModule } from './phone/phone.module';
export { SplitPipeModule } from './split/split.module';
export { CpfCnpjPipeModule } from './cpf-cnpj/cpf-cnpj.module';
export { IntDatePipeModule } from './int-date/int-date.module';
export { TokenizePipeModule } from './tokenize/tokenize.module';
export { TruncateNumPipeModule } from './truncate/truncate.module';
export { ArraySortPipeModule } from './array-sort/array-sort.module';
export { CalcMonthPipeModule } from './calc-month/calc-month.module';
export { FirstNamePipeModule } from './first-name/fisrt-name.module';
export { ShowMonthPipeModule } from './show-month/show-month.module';
export { MarkdownToHtmlPipeModule } from './markdown/markdown.module';
export { SuitabilityPipeModule } from './suitability/suitability.module';
export { DateISOStringPipeModule } from './date-iso-string/date-iso-string.module';
export { ProductsLimitPipeModule } from './products-limit/products-limit.module';
export { SafePipeModule } from './safe/safe.module';
